import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { ContentCopy, Check } from '@mui/icons-material';

const CustomerCredentialsDialog = ({
  open,
  customerData,
  onClose,
}) => {
  const [copiedField, setCopiedField] = React.useState(null);

  const handleCopy = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  // Don't return null if customerData is missing, still show the dialog
  // if (!customerData) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      data-testid="credentials-dialog" // Add this for easier debugging
    >
      <DialogTitle>Customer Created Successfully</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <Typography variant="body1" color="text.secondary">
            Please save these credentials for the new customer:
          </Typography>

          {customerData ? (
            <>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Email
                </Typography>
                <TextField
                  value={customerData.email}
                  fullWidth
                  size="small"
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => handleCopy(customerData.email, 'email')}
                          size="small"
                        >
                          {copiedField === 'email' ? <Check color="success" /> : <ContentCopy />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Password
                </Typography>
                <TextField
                  value={customerData.password}
                  type="text"
                  fullWidth
                  size="small"
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => handleCopy(customerData.password, 'password')}
                          size="small"
                        >
                          {copiedField === 'password' ? <Check color="success" /> : <ContentCopy />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </>
          ) : (
            <Typography color="error">
              No customer data available
            </Typography>
          )}

          <Box sx={{ backgroundColor: '#f5f5f5', p: 2, borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">
              <strong>Note:</strong> These credentials have been automatically saved. 
              The customer can use them to log into their account.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomerCredentialsDialog;